export default "__VITE_ASSET__DWOyV94C__"